export const conditionValuesPayload = (conditions = []) => conditions
    .filter(condition => !condition.read_only && (
        condition.input_type === 'boolean'
        || (condition.input_type === 'number' && condition.code === 'implant_placed_quantity')
    ))
    .map(condition => ({
        service_condition_id: Number(condition.service_condition_id),
        is_satisfied: !!condition.is_satisfied,
        value_number: condition.value_number ?? condition.metadata?.value_number ?? null,
        occurred_at: condition.occurred_at || null,
        note: condition.note || null,
        metadata: condition.metadata || null,
    }));

export const updateCheckedCondition = (
    conditions = [],
    serviceConditionId,
    checked,
    currentDate
) => conditions.map(condition => {
    if (Number(condition.service_condition_id) !== Number(serviceConditionId)) return condition;

    return {
        ...condition,
        is_satisfied: checked,
        occurred_at: checked ? (condition.occurred_at || currentDate) : null,
    };
});

export const visibleAppointmentConditions = (conditions = []) => conditions.filter(condition => {
    if (condition.read_only) return false;
    if (condition.input_type !== 'boolean'
        && !(condition.input_type === 'number' && condition.code === 'implant_placed_quantity')) {
        return false;
    }

    const visibleWhen = condition.config?.visible_when;
    if (!visibleWhen?.condition_code) return true;
    const dependency = conditions.find(row => row.code === visibleWhen.condition_code);

    return !!dependency?.is_satisfied === !!visibleWhen.is_satisfied;
});

export const updateNumberCondition = (conditions = [], serviceConditionId, value) => (
    conditions.map(condition => (
        Number(condition.service_condition_id) === Number(serviceConditionId)
            ? {
                ...condition,
                value_number: value,
                is_satisfied: value !== null && value !== '' && Number(value) >= 0,
                metadata: { ...(condition.metadata || {}), value_number: value },
            }
            : condition
    ))
);

export const implantQuantityValidationMessage = (conditions = [], serviceQuantity = null) => {
    const condition = visibleAppointmentConditions(conditions)
        .find(row => row.code === 'implant_placed_quantity');
    if (!condition) return null;

    const value = condition.value_number ?? condition.metadata?.value_number;
    if (value === null || value === '') {
        return 'Vui lòng nhập Số trụ implant đã cắm trước khi cập nhật lịch hẹn.';
    }
    if (typeof value === 'boolean' || !Number.isFinite(Number(value))) {
        return 'Số trụ implant đã cắm phải là số hợp lệ.';
    }
    if (Number(value) < 0) return 'Số trụ implant đã cắm không được là số âm.';
    if (Number(value) === 0) return 'Số trụ implant đã cắm phải lớn hơn 0.';
    if (!Number.isInteger(Number(value))) return 'Số trụ implant đã cắm phải là số nguyên.';

    const maximum = condition.config?.max_source === 'customer_service.quantity'
        ? Number(serviceQuantity)
        : Number(condition.config?.max);
    if (Number.isFinite(maximum) && Number(value) > maximum) {
        return `Số trụ implant đã cắm không được vượt quá số lượng dịch vụ (${maximum}).`;
    }

    return null;
};

export const appointmentConditionErrors = (
    conditionItems = {},
    loadedAppointmentServiceIds = []
) => loadedAppointmentServiceIds.reduce((errors, appointmentServiceId) => {
    const item = conditionItems[appointmentServiceId];
    const message = implantQuantityValidationMessage(
        item?.condition_values || [],
        item?.quantity
    );
    return message ? { ...errors, [appointmentServiceId]: message } : errors;
}, {});

export const buildAppointmentServiceUpdates = (
    appointmentServices = [],
    formValues = {},
    conditionItems = {},
    loadedAppointmentServiceIds = []
) => {
    const loadedIds = new Set(loadedAppointmentServiceIds.map(Number));

    return appointmentServices
        .filter(appointmentService => appointmentService?.id && appointmentService?.customer_service)
        .map(appointmentService => {
            const appointmentServiceId = Number(appointmentService.id);
            const update = {
                appointment_service_id: appointmentServiceId,
                status: formValues[`service_status_${appointmentService.id}`],
            };

            if (loadedIds.has(appointmentServiceId)) {
                update.condition_values = conditionValuesPayload(
                    conditionItems[appointmentServiceId]?.condition_values || []
                );
            }

            return update;
        });
};
